import { Component, h, Host, JSX, Prop } from '@stencil/core';
import { TButton } from '../../entities/content';
import globalDataLayerService from '../../services/analytics/global-data-layer-service';
import { navContentStore } from '../../state/nav-content-store';
import {
  ClickElementTypes,
  EventActions,
  NavigationMode,
  NavigationModeType,
  NavigationTheme,
  NavigationThemeType
} from '../../utility/constants';
import { constructThemeClass, getRightTheme } from '../../utility/helper';

@Component({
  tag: 'phn-burger-button',
  styleUrl: 'burger-button.scss',
  scoped: true
})
export class BurgerButton {
  @Prop() hideLabel!: boolean;
  @Prop() alignLabel!: string;
  @Prop() isLoading = false;
  @Prop() theme: NavigationThemeType = NavigationTheme.light;
  @Prop() mode: NavigationModeType = NavigationMode.navbar;

  private sendDataLayerEvent(menu: TButton) {
    globalDataLayerService.pushDataLayerEvent(EventActions.MORE_CLICK, {
      componentClick: {
        clickElementId: menu.id,
        clickElementName: menu.text,
        targetElement: 'level1_drawer',
        clickElementType: ClickElementTypes.Button
      }
    });
  }

  render(): JSX.Element {
    const { menu } = navContentStore.state;

    return (
      <Host class={`${constructThemeClass(this.mode, this.theme)}-theme`}>
        <phn-p-button-pure
          theme={getRightTheme(this.theme, this.mode)}
          onClick={() => this.sendDataLayerEvent(menu)}
          aria={{ 'aria-haspopup': 'dialog', 'aria-label': 'open the menu' }}
          align-label={this.alignLabel}
          icon="menu-lines"
          loading={this.isLoading}
          size="inherit"
          hideLabel={this.hideLabel}
        >
          {menu.text}
        </phn-p-button-pure>
      </Host>
    );
  }
}
